// Constants
import { MOBILE_LANDSCAPE_ORIENTATION } from './constants/contract-viewer.handlers.utils.constants';

const isMobileAndIsLandscape = (): boolean =>
  window.screen.orientation.type.includes(MOBILE_LANDSCAPE_ORIENTATION);

export { isMobileAndIsLandscape };
